import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.is-integer";
import "core-js/modules/es.number.is-nan";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import _typeof from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/typeof";

/*
 * @Author: dongtao
 * @Desc: 基于HUI-VUE表单验证的集成方法
 */

/*
** attribute   value       数据格式    说明
*1.required    true/false  boolen     是否必填
*2.type        ip/mobile/name/common/code/url/email/tel/telOrMobile/port/mac/identity/int  string   类型
*3.fixLength   1/2...      number     固定长度
*4.minLength   1/2...      number     最小长度
*5.maxLength   1/2...      number     最大长度
*6.minValue    1/2...      number     最小值
*7.maxValue    1/2...      number     最大值
*8.extra       [{ required: true, message: '必填项' , trigger: 'blur'}]   array   自定义内容
* */
// input type=number类型的输入框
var rules = {
  ip: new RegExp('^(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|[1-9])\\.' + '(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|\\d)\\.' + '(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|\\d)\\.' + '(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|\\d)$'),
  mobile: /^[1][1-9][0-9]{9}$/,
  // 姓名特殊字符校验
  name: /[^A-Za-z0-9\u4e00-\u9fa5]+/,
  // 案号特殊字符校验 中英文括号都要支持
  caseNumber: /[^A-Za-z0-9\u4e00-\u9fa5\-()（）]+/,
  // 不包含特殊字符\/:*?"<|'%>&校验
  common: /[\\/:*?"<|'%>&]/,
  // 证件号码
  card: /[^A-Za-z0-9]+/,
  // 编号只允许字母、数字和下划线！
  code: /[^A-Za-z0-9_]+/,
  url: /((http|https):\/\/)(([a-zA-Z0-9._-]+\.[a-zA-Z]{2,6})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,4})*(\/[a-zA-Z0-9&%_./-~-]*)?/,
  email: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/,
  tel: /(^[0][1-9]{2,3}-[1-9]{1}[0-9]{6,8}$)|(^[1-9]{1}[0-9]{6,8}$)/,
  telOrMobile: /(^(\d{3,4}-)?\d{7,8})$|(^[1][1-9][0-9]{9})$/,
  fixLength: 0,
  identity: {
    // 15位身份证
    isIDCard1: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/,
    // 18位身份证
    isIDCard2: /^[1-9]\d{5}(19\d{2}|[2-9]\d{3})((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])(\d{4}|\d{3}X)$/i,
    aCity: {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门',
      91: '国外'
    },
    // 最后一位身份证的号码
    stard: '10X98765432',
    // 1-17系数
    first: [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
  }
};
var info = {
  required: '此项为必填项',
  ip: '请输入有效的IP',
  mobile: '请输入有效的手机号',
  name: '请输入数字、字母、中文',
  caseNumber: '请输入数字、字母、中文、(、)或-',
  port: '请输入 1 到 65535 之间的端口值',
  common: '请输入不包含\\/:*?"<|\'%>',
  code: '请输入有效的编号(字母、数字、下划线的组合)',
  card: '请输入有效的证件号码',
  url: '请输入有效的URL',
  email: '请输入有效的邮箱地址',
  tel: '请输入有效的电话号码',
  telOrMobile: '请输入有效的手机号或者电话号码',
  mac: '请输入有效的mac地址',
  identity: '请输入有效的身份证号码',
  int: '请输入正整数'
};

var validateIp = function validateIp(rule, value, callback) {
  if (value && value.length > 0) {
    var pattern = rules.ip;

    if (value && (!pattern.test(value) || value === '255.255.255.255')) {
      callback(new Error(info.ip));
    }

    callback();
  }

  callback();
};

var validateMobile = function validateMobile(rule, value, callback) {
  if (value && value.length > 0) {
    if (rules.mobile.test(value)) {
      callback();
    }

    callback(new Error(info.mobile));
  }

  callback();
};

var validateName = function validateName(rule, value, callback) {
  if (value && value.trim().length > 0) {
    if (rules.name.test(value.trim())) {
      callback(new Error(info.name));
    }

    callback();
  }

  callback();
};

var validateCaseNumber = function validateCaseNumber(rule, value, callback) {
  if (value && value.trim().length > 0) {
    if (rules.caseNumber.test(value.trim())) {
      callback(new Error(info.caseNumber));
    }

    callback();
  }

  callback();
};

var validatePort = function validatePort(rule, value, callback) {
  if (value) {
    if (Number.isNaN(value) || value > 65535 || value < 1) {
      callback(new Error(info.port));
    }

    callback();
  }

  callback();
};

var validateCommon = function validateCommon(rule, value, callback) {
  if (value && value.trim().length > 0) {
    if (rules.common.test(value.trim())) {
      callback(new Error(info.common));
    }

    callback();
  }

  callback();
};

var validateCode = function validateCode(rule, value, callback) {
  if (value && value.trim().length > 0) {
    if (rules.code.test(value.trim())) {
      callback(new Error(info.code));
    }

    callback();
  }

  callback();
};

var validateCard = function validateCard(rule, value, callback) {
  if (value && value.trim().length > 0) {
    if (rules.card.test(value.trim())) {
      callback(new Error(info.card));
    }

    callback();
  }

  callback();
};

var validateUrl = function validateUrl(rule, value, callback) {
  if (value && value.trim().length > 0) {
    if (rules.url.test(value.trim())) {
      callback();
    }

    callback(new Error(info.url));
  }

  callback();
};

var validateEmail = function validateEmail(rule, value, callback) {
  if (value && value.trim().length > 0) {
    if (rules.email.test(value.trim())) {
      callback();
    }

    callback(new Error(info.email));
  }

  callback();
};

var validateTel = function validateTel(rule, value, callback) {
  if (value && value.trim().length > 0) {
    if (rules.tel.test(value.trim())) {
      callback();
    }

    callback(new Error(info.tel));
  }

  callback();
};

var validateTelOrMobile = function validateTelOrMobile(rule, value, callback) {
  if (value && value.trim().length > 0) {
    if (rules.telOrMobile.test(value.trim())) {
      callback();
    }

    callback(new Error(info.telOrMobile));
  }

  callback();
};

var validateMac = function validateMac(rule, value, callback) {
  var macs = value.indexOf(':') > 0 ? value.split(':') : value.split('-');

  if (!macs || macs.length !== 6) {
    callback(new Error(info.mac));
  }

  for (var s = 0; s < 6; s++) {
    var temp = parseInt(macs[s], 16);

    if (Number.isNaN(temp) || temp < 0 || temp > 255) {
      callback(new Error(info.mac));
    }
  }

  callback();
};

var dateToString = function dateToString(date) {
  if (date instanceof Date) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    month = month < 10 ? "0".concat(month) : month;
    var day = date.getDate();
    day = day < 10 ? "0".concat(day) : day;
    return "".concat(year).concat(month).concat(day);
  }

  return '';
};

var validateIdentity = function validateIdentity(rule, value, callback) {
  var sum = 0;
  var year = '';
  var month = '';
  var day = '';
  var birthday = '';
  var _rules$identity = rules.identity,
      isIDCard1 = _rules$identity.isIDCard1,
      isIDCard2 = _rules$identity.isIDCard2,
      aCity = _rules$identity.aCity,
      first = _rules$identity.first,
      stard = _rules$identity.stard;

  if (value && value.length > 0) {
    // 身份证号为15位
    if (value.length === 15) {
      year = "19".concat(value.substr(6, 2));
      month = value.substr(8, 2);
      day = value.substr(10, 2);
      birthday = "19".concat(value.substr(6, 6));

      if (!isIDCard1.test(value)) {
        callback(new Error(info.identity));
      } // 身份证号为18位

    } else if (value.length === 18) {
      year = value.substr(6, 4);
      month = value.substr(10, 2);
      day = value.substr(12, 2);
      birthday = value.substr(6, 8);

      if (!isIDCard2.test(value)) {
        callback(new Error(info.identity));
      } // 检测身份证最后一位是否合法


      for (var i = 0; i < value.length - 1; i++) {
        sum += parseInt(value[i]) * first[i];
      }

      var result = sum % 11; // 计算出来的最后一位身份证号码

      var last = stard[result];

      if (value[value.length - 1].toUpperCase() !== last) {
        callback(new Error(info.identity));
      }
    } // 检测证件地区是否合法


    if (aCity[parseInt(value.substr(0, 2))] == null) {
      callback(new Error(info.identity));
    } // 检测出生年月是否合法


    if (birthday !== dateToString(new Date("".concat(year, "/").concat(month, "/").concat(day)))) {
      callback(new Error(info.identity));
    }

    callback();
  }

  callback();
};

var validateInt = function validateInt(rule, value, callback) {
  if (value) {
    if (value < 0) {
      callback(new Error(info.int));
    }

    callback();
  }

  callback();
};

var validateFixLength = function validateFixLength(fixLength) {
  return function (rule, value, callback) {
    if (value && value.trim().length > 0) {
      if (value.trim().length !== fixLength) {
        callback(new Error("\u8BF7\u8F93\u5165".concat(fixLength, "\u4E2A\u5B57\u7B26")));
      }

      callback();
    }

    callback();
  };
};

var validateMin = function validateMin(min) {
  return function (rule, value, callback) {
    if (value) {
      var formatValue = Math.floor(value);

      if (!Number.isInteger(formatValue)) {
        callback(new Error('请输入数字值'));
      } else if (formatValue < min) {
        callback(new Error("\u8BF7\u8F93\u5165\u4E0D\u5C0F\u4E8E".concat(min, "\u7684\u503C")));
      }
    }

    callback();
  };
};

var validateMax = function validateMax(max) {
  return function (rule, value, callback) {
    if (value) {
      var formatValue = Math.floor(value);

      if (!Number.isInteger(formatValue)) {
        callback(new Error('请输入数字值'));
      } else if (formatValue > max) {
        callback(new Error("\u8BF7\u8F93\u5165\u4E0D\u5927\u4E8E".concat(max, "\u7684\u503C")));
      }

      callback();
    }

    callback();
  };
};

var validateRequired = function validateRequired(rule, value, callback) {
  if (_typeof(value) === 'object') {
    if (value instanceof Array && value.length === 0) {
      callback(new Error(info.required));
    }
  } else {
    if (value && value instanceof String && value.trim().length === 0) {
      callback(new Error(info.required));
    }
  }

  callback();
};

var validateor = function validateor(obj) {
  var validateorArray = [];

  if (obj) {
    var _obj$trigger = obj.trigger,
        trigger = _obj$trigger === void 0 ? 'blur' : _obj$trigger; // 判断是否为必填

    if (obj.hasOwnProperty('required')) {
      validateorArray.push({
        validator: validateRequired,
        trigger: trigger
      }, {
        required: true,
        message: info.required,
        trigger: trigger
      });
    } // 判断type的类型


    if (obj.hasOwnProperty('type')) {
      switch (obj.type) {
        case 'ip':
          validateorArray.push({
            validator: validateIp,
            trigger: trigger
          });
          break;

        case 'mobile':
          validateorArray.push({
            validator: validateMobile,
            trigger: trigger
          });
          break;

        case 'name':
          validateorArray.push({
            validator: validateName,
            trigger: trigger
          });
          break;

        case 'caseNumber':
          validateorArray.push({
            validator: validateCaseNumber,
            trigger: trigger
          });
          break;

        case 'port':
          validateorArray.push({
            validator: validatePort,
            trigger: trigger
          });
          break;

        case 'common':
          validateorArray.push({
            validator: validateCommon,
            trigger: trigger
          });
          break;

        case 'code':
          validateorArray.push({
            validator: validateCode,
            trigger: trigger
          });
          break;

        case 'card':
          validateorArray.push({
            validator: validateCard,
            trigger: trigger
          });
          break;

        case 'url':
          validateorArray.push({
            validator: validateUrl,
            trigger: trigger
          });
          break;

        case 'email':
          validateorArray.push({
            validator: validateEmail,
            trigger: trigger
          });
          break;

        case 'tel':
          validateorArray.push({
            validator: validateTel,
            trigger: trigger
          });
          break;

        case 'telOrMobile':
          validateorArray.push({
            validator: validateTelOrMobile,
            trigger: trigger
          });
          break;

        case 'mac':
          validateorArray.push({
            validator: validateMac,
            trigger: trigger
          });
          break;

        case 'identity':
          validateorArray.push({
            validator: validateIdentity,
            trigger: trigger
          });
          break;

        case 'int':
          validateorArray.push({
            validator: validateInt,
            trigger: trigger
          });
          break;

        default:
          console.error('【Validate Error】No such type');
          return [];
      }
    } // 固定长度


    if (obj.hasOwnProperty('fixLength') && obj.fixLength) {
      if (Number.isNaN(obj.fixLength)) {
        console.error('【Validate Error】fixLength is not a Number');
        return [];
      }

      validateorArray.push({
        validator: validateFixLength(obj.fixLength),
        trigger: trigger
      });
    } // 最小长度


    if (obj.hasOwnProperty('minLength') && obj.minLength) {
      if (Number.isNaN(obj.minLength)) {
        console.error('【Validate Error】minLength is not a Number');
        return [];
      }

      validateorArray.push({
        min: obj.minLength,
        message: "\u8F93\u5165\u7684\u9879\u7684\u957F\u5EA6\u4E0D\u80FD\u5C11\u4E8E".concat(obj.minLength, "\u4E2A\u5B57\u7B26"),
        trigger: trigger
      });
    } // 最大长度


    if (obj.hasOwnProperty('maxLength') && obj.maxLength) {
      if (Number.isNaN(obj.maxLength)) {
        console.error('【Validate Error】maxLength is not a Number');
        return [];
      }

      validateorArray.push({
        max: obj.maxLength,
        message: "\u8F93\u5165\u7684\u9879\u7684\u957F\u5EA6\u4E0D\u80FD\u8D85\u8FC7".concat(obj.maxLength, "\u4E2A\u5B57\u7B26"),
        trigger: trigger
      });
    } // 最小值


    if (obj.hasOwnProperty('minValue') && obj.minValue) {
      if (Number.isNaN(obj.minValue)) {
        console.error('【Validate Error】maxLength is not a Number');
        return [];
      }

      validateorArray.push({
        validator: validateMin(obj.minValue),
        trigger: trigger
      });
    } // 最大值


    if (obj.hasOwnProperty('maxValue') && obj.maxValue) {
      if (Number.isNaN(obj.maxValue)) {
        console.error('【Validate Error】maxLength is not a Number');
        return [];
      }

      validateorArray.push({
        validator: validateMax(obj.maxValue),
        trigger: trigger
      });
    } // 自定义


    if (obj.hasOwnProperty('extra') && obj.extra) {
      if (Array.isArray(obj.extra)) {
        if (obj.extra.length > 0) {
          validateorArray = validateorArray.concat(obj.extra);
        }
      } else {
        console.error('【Validate Error】extra is not a Array');
        return [];
      }
    }
  }

  return validateorArray;
};

var validateInfo = info;
export { validateor, validateInfo };